import React, { FC } from "react";
import { List, Spin } from "antd";
import moment from "moment";
import { Link } from "react-router-dom";

import { APIRoutes } from "../../http";
import useHttpGet from "../../hooks/useHttpGet";
import CommonService from "../../services/common.service";
import { IResultResponse } from "../../models/response/result.model";
import { useTypedSelector } from "../../hooks/useTypedSelector";
import { ICryptoIndex } from "../../models/cryptoindex.model";
import long2 from "../../assets/media/images/long2.png";
import { UIRoutes } from "../../router";
import { MagicPagesTypes } from "../../services/enums";

interface ILabel {
  name: string;
  label: string;
  render?: (item?: any) => string | React.ReactNode;
}

const Info: FC = () => {
  const indexId = useTypedSelector(({ ci }) => ci.indexId);

  const { fetchedData, loading } = useHttpGet<IResultResponse<ICryptoIndex>>(
    `${APIRoutes.CRYPTO_INDEX}/${indexId}`,
    {
      dependencies: [indexId],
      condition: !!indexId,
    }
  );

  const labels: ILabel[] = [
    {
      name: "updatedOn",
      label: "Update on",
      render: (name) => moment(getValue(name)).format("LLL"),
    },
    {
      name: "todaysMinValue",
      label: "Day range",
      render: () =>
        `${getValue("todaysMinValue")} - ${getValue("todaysMaxValue")}`,
    },
    {
      name: "changePercent7D",
      label: "7 days change",
      render: (name) => `${getValue(name)} %`,
    },
    {
      name: "changePercent1M",
      label: "1 month change",
      render: (name) => `${getValue(name)} %`,
    },
    {
      name: "changePercent3M",
      label: "3 months change",
      render: (name) => `${getValue(name)} %`,
    },
    {
      name: "",
      label: "",
      render: () => (
        <Link
          to={`/${UIRoutes.VIEW_PAGE_BASE}/IndexMethodology/${MagicPagesTypes.Methodology}`}
        >
          Index Methodology
        </Link>
      ),
    },
  ];

  const getValue = (name: string) => CommonService.getProperty(fetchedData.result.quotesSummary, name);

  return (
    <Spin spinning={loading}>
      <h1 className="fs-36">
        {CommonService.toLocalNum(fetchedData?.result?.quotesSummary?.currentValue)}
      </h1>

      <h2 className={CommonService.numberColor(fetchedData?.result?.quotesSummary?.change24H)}>
        <span className="mr-0_5">{`${fetchedData?.result?.quotesSummary?.changePercent24H || ""
          } %`}</span>
        <span>{fetchedData?.result?.quotesSummary?.change24H}</span>
      </h2>

      <List
        dataSource={fetchedData?.result?.quotesSummary ? labels : []}
        renderItem={(item: ILabel) => (
          <List.Item>
            <div className="d-flex align-items-center justify-content-between w-100">
              <span>{item.label}</span>
              <span>
                {item?.render ? item.render(item.name) : getValue(item.name)}
              </span>
            </div>
          </List.Item>
        )}
      />

      <a href={"/"}>
        <div className="logo">
          <img src={long2} alt="logo" />
        </div>
      </a>
    </Spin>
  );
};

export default Info;
